<template>
  <div class="content-430">
    <header>
      <Tabs v-model="activeTab">
        <TabPane label="优惠券管理" name="Manage"></TabPane>
        <TabPane label="优惠券明细" name="List"></TabPane>
      </Tabs>
    </header>
    <div class="main">
      <component :is="activeTab"></component>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {

  name: 'CourseCenterCouponIndex',
  components: {
    Manage: () =>
      import('./components/Manage.vue'),
    List: () =>
      import('./components/List.vue')
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CourseCenterCouponIndex');
    next();
  },
  data() {
    return {
      activeTab: 'Manage'

    };
  },
  methods: {
    ...mapMutations(['SET_CACHEROUTE', 'PUSH_CACHEROUTE'])
  }
};
</script>

<style lang="scss" scoped>
</style>
